export const DisposalReasonGismtSelectPluginSettings: IPluginSettings = {
    name: 'Причины выбытия ГИС МТ',
    mnemocode: 'disposal_reason_gismt_select_plugin',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 100
        }, {
            order: 2,
            propertyName: 'name',
            propertyType: 'string',
            displayName: 'Причина выбытия',
            visibility: true,
            width: 400
        }, {
            order: 3,
            propertyName: 'comment',
            propertyType: 'string',
            displayName: 'Комментарий',
            visibility: true,
            width: 350
        }, {
            order: 4,
            propertyName: 'mnemocode',
            propertyType: 'string',
            displayName: 'Код',
            visibility: true,
            width: 200
        }
    ],
}
